import React from 'react';
import './SevenSegmentTimeDisplay.css';

const SevenSegmentDigit = ({ digit }) => {
  const segments = [
    digit !== '1' && digit !== '4',
    digit !== '5' && digit !== '6',
    digit !== '2',
    digit !== '1' && digit !== '4' && digit !== '7',
    (digit === '0' || digit === '2' || digit === '6' || digit === '8'),
    digit !== '1' && digit !== '2' && digit !== '3' && digit !== '7',
    digit !== '0' && digit !== '1' && digit !== '7',
  ];

  return (
    <div className="seven-segment-digit">
      {segments.map((active, index) => (
        <div key={index} className={`segment_time ${active ? 'active' : ''}`} />
      ))}
    </div>
  );
};

const SevenSegmentTimeDisplay = ({ time }) => {
  const [hours, minutes, seconds] = time.split(':').map(part => part.trim());

  return (
    <div className="seven-segment-time-display">
      <SevenSegmentDigit digit={hours[0]} />
      <SevenSegmentDigit digit={hours[1]} />
      <div className="unit">H</div>
      <div className="separator"> : </div>
      <SevenSegmentDigit digit={minutes[0]} />
      <SevenSegmentDigit digit={minutes[1]} />
      <div className="unit">M</div>
      <div className="separator"> : </div>
      <SevenSegmentDigit digit={seconds[0]} />
      <SevenSegmentDigit digit={seconds[1]} />
      <div className="unit">S</div>
    </div>
  );
};

export default SevenSegmentTimeDisplay;